import _ from 'lodash';

export function findMissingFilesInSession(session) {
  const virtualFiles = _.filter(
    session.files,
    file => file.virtualFile && file.active
  );

  const activeFiles = _.filter(
    session.files,
    file => !file.virtualFile && file.active && !file.missing
  );
  let missingFiles = [];
  _.forEach(virtualFiles, (file) => {
    _.forEach(file.joins, (join) => {
      if(!_.find(activeFiles,(activeFiles, (activeFile) => activeFile.filename === join.sourceFilename))) {
        missingFiles.push(join.sourceFilename);
      }
      if(!_.find(activeFiles,(activeFiles, (activeFile) => activeFile.filename === join.targetFilename))) {
        missingFiles.push(join.targetFilename);
      }
    } )

  });
  return _.uniq(missingFiles);
}
